import { Route, Routes } from "react-router-dom";
import Main from "./views/Main";
import {
  Contribution,
  Entrepreneurship,
  HumanPractices,
  Notebook,
  Safety,
  SustainableDevelopment,
  Team,
  Education,
  Description,
  EngineeringSuccess,
  Experiments,
  Model,
  HardWare,
  Implementation,
  PofC,
  Results,
  Awards,
  PlantSynheticBiology,
  Attribution,
  PartCollection,
} from "./views";
import { Navbar } from "./components";
import { Footer } from "./components";

const App = () => {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative z-10 flex-col">
      <Navbar />

      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/team" element={<Team />} />
        <Route path="/part-collection" element={<PartCollection />} />
        <Route path="/attributions" element={<Attribution />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/human-practices" element={<HumanPractices />} />
        <Route path="/education" element={<Education />} />
        <Route path="/entrepreneurship" element={<Entrepreneurship />} />
        <Route
          path="/human-practices/sustainable-development"
          element={<SustainableDevelopment />}
        />
        <Route path="/project/notebook" element={<Notebook />} />
        <Route path="/description" element={<Description />} />
        <Route path="/contribution" element={<Contribution />} />
        <Route path="/engineering" element={<EngineeringSuccess />} />
        <Route path="/project/experiments" element={<Experiments />} />
        <Route path="/model" element={<Model />} />
        <Route path="/hardware" element={<HardWare />} />
        <Route path="/project/implementation" element={<Implementation />} />
        <Route
          path="/project/plant-synthetic-biology"
          element={<PlantSynheticBiology />}
        />
        <Route path="/project/proof-of-concept" element={<PofC />} />
        <Route path="/project/results" element={<Results />} />
        <Route path="/project/awards" element={<Awards />} />
      </Routes>

      <Footer />
    </div>
  );
};

export default App;
